import gql from 'graphql-tag';

export default gql`
    query GetAllCarriers($input: CarrierMasterDataInput) {
        getAllCarriers(input: $input) {
            id
            companyName
            type
            stateId
            isActive
            extSystemIdentifier
            extSystemIdentifier2
            extSystemName
            activeInactiveDate
            activeInactiveUser
            name
            addressLine1
            addressLine2
            notes
            city
            zip
            phoneNumber
            email
            isCompliant
            acronym
        }
    }
`;
